import React, { Component } from 'react';

import VisibilitySensor from 'react-visibility-sensor';
import classNames from 'classnames';

class Visible extends Component {
  seen = false;

  onChange = (visible) => {
    if (!visible) {
      let playing = document.querySelectorAll('.Video.is-loud');

      if (playing.length) {
        for (var i = 0; i < playing.length; i++) {
          let el = playing[i];
          el.muted = true;
          el.volume = 0;
          el.classList.remove('is-loud');
        }
      }
    }
  };

  render() {
    let bottom = window.innerWidth < 764 ? 50 : 50;

    return (
      <VisibilitySensor
        onChange={this.onChange}
        partialVisibility={true}
        offset={{ bottom: bottom, top: -100 }}
      >
        {({ isVisible }) => {
          /*if(isVisible) {
	    		this.seen = true
	    	}*/

          //const seen = isVisible ? true : this.seen ? true : false

          let cls = classNames(
            'Visible',
            { 'Visible--seen': isVisible },
            { 'Visible--hidden': !isVisible },
          );

          return <div className={cls}>{this.props.children}</div>;
        }}
      </VisibilitySensor>
    );
  }
}

export default Visible;



// WEBPACK FOOTER //
// ./src/js/components/Visible.js